module.exports = __webpack_public_path__ + "img/503.1554ea00.png";